const Font = (isTablet) => ({
  h: {
    fontFamily: isTablet ? 'roboto-bold' : 'poppins-bold',
    fontSize: 50,
    lineHeight: 48
  },
  h1: {
    fontFamily: isTablet ? 'roboto-bold' : 'poppins-bold',
    fontSize: 34,
    lineHeight: 48
  },
  h2: {
    fontFamily: isTablet ? 'roboto-bold' : 'poppins-bold',
    fontSize: 26,
    lineHeight: 48
  },
  h3: {
    fontFamily: isTablet ? 'roboto-bold' : 'poppins-bold',
    fontSize: 23,
    lineHeight: 48
  },
  h4: {
    fontFamily: isTablet ? 'roboto-bold' : 'poppins-bold',
    fontSize: 18,
    lineHeight: 24
  },
  subtitle: {
    fontFamily: 'roboto-regular',
    fontSize: 16,
    lineHeight: 22
  },
  subtitleBold: {
    fontFamily: 'roboto-bold',
    fontSize: 16,
    lineHeight: 30
  },
  body1: {
    fontFamily: 'roboto-regular',
    fontSize: 16,
    lineHeight: 22
  },
  body1Bold: {
    fontFamily: 'roboto-bold',
    fontSize: 16,
    lineHeight: 30
  },
  body2: {
    fontFamily: 'roboto-regular',
    fontSize: 14,
    lineHeight: 20
  },
  body2Bold: {
    fontFamily: 'roboto-bold',
    fontSize: 14,
    lineHeight: 24
  },
  body3: {
    fontFamily: 'roboto-regular',
    fontSize: 12,
    lineHeight: 14
  },
  body3Bold: {
    fontFamily: 'roboto-bold',
    fontSize: 12,
    lineHeight: 18
  }
})

const Borders = (theme) => ({
  Normal: {
    borderWidth: 1,
    borderColor: theme.INPUT_COLOR,
    borderStyle: 'solid',
    borderRadius: 5
  },
  Active: {
    borderWidth: 1,
    borderColor: theme.LOCHMARA,
    borderStyle: 'solid',
    borderRadius: 5
  },
  Complete: {
    borderWidth: 1,
    borderColor: theme.OUTER_SPACE,
    borderStyle: 'solid',
    borderRadius: 5
  },
  Error: {
    borderWidth: 1,
    borderColor: theme.RED_ORANGE,
    borderStyle: 'solid',
    borderRadius: 5
  }
})

const Shadow = (theme) => ({
  Main: {
    shadowColor: theme.BUNKER,
    shadowOffset: {
      width: 0,
      height: 1
    },
    shadowOpacity: 0.18,
    shadowRadius: 1.00,

    elevation: 1
  },
  Card: {
    shadowColor: theme.SLATE_GRAY,
    shadowOpacity: 0.3,
    shadowRadius: 6,
    shadowOffset: {
      height: 1,
      width: 0
    },
    zIndex: 99,

    elevation: 4
  }
})

export default { Font, Borders, Shadow }
